/* eslint-disable */
if (process.env.NODE_ENV === 'test') {
  require = require('src/utils/jestWebpackPolyfill').default;
}
/* eslint-enable */

const rscRequire = require.context('.', false, /^\.\/(?!.*\.spec\.js$).*\.js$/);
const regName = /^\.\/(.*)\.js$/;
const resource = {};

rscRequire.keys().map((path) => {
  const filter = rscRequire(path).default;
  const name = path.replace(regName, '$1');
  resource[name] = filter;
  return resource;
});

delete resource.index;
export default resource;
